import services from 'services/services';
import * as types from '../../types';

// Import helpers
import { checkFetchErrors } from '../../helpers_actions/convert_helpers';

// ******************** FETCH VOD POSTER FILES TO EDIT ********************
export const fetchVodPoster = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_VOD_POSTER_FILES_LOADING,
			payload: true
		});

		const response = await services.get(
			`/assets/${id}/list?model_type=vod&collection=poster`
		);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_VOD_POSTER_FILES_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_VOD_POSTER_FILES_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
